<template>
	<div class="join-pitch">
		<div class="image-container">
			<img
				src="/images/user-group-1.webp"
				width="128"
				height="44"
				alt="join pitch image"
			/>
		</div>

		<span
			:class="props.isWhite && 'text-white'"
			class="text-center md:text-left"
		>
			Join 11,226+ hard-working traders inside
		</span>
	</div>
</template>

<script setup>
const props = defineProps({
	isWhite: Boolean
});
</script>
<style lang="scss">
@use "~/assets/utils.scss" as *;

.image-container {
	display: flex;

	img {
		position: relative;
		height: 40px;
		width: auto;

		&:not(:first-child) {
			margin-left: -20px;

			@include breakpoint(lg) {
				margin-left: -16px;
			}
		}

		@include breakpoint(lg) {
			height: 44px;
		}
	}
}

.join-pitch {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;
	justify-content: center;

	@include breakpoint(md) {
		justify-content: flex-start;
	}

	span {
		color: $slate-500;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 160%;
		opacity: 0.5;

		&.text-white {
			color: $slate-300 !important;
			opacity: 1;
		}
	}
}
</style>
